import menubox from 'url:../../assets/taco/menu-frame.png';
import menutitle from 'url:../../assets/taco/menu-text.png';
import kibble from 'url:../../assets/taco/kibble-icon.png';
import freetoy from 'url:../../assets/taco/freetoy-icon.png';

export function TACOMENU() {
    return <div className="v-box pos-rel" style={{
        width: 640,
        height: 920
    }}>
        {/* <img src={menugif} className="pos-abs" style={{ left: "-50%", top: "-33%", width: "190%"}} /> */}
        <img src={menubox} className="pos-abs width-100p" />
        <img src={menutitle} className="pos-abs width-256" style={{ left: "27%", top: "3%"}} />
        <div className="height-100p" style={{
            padding: "256px 48px 48px 48px"
        }}>
            <div className="pos-rel height-100p">
                <MenuText text="Main Attractions" x={0} y={0} size={28} header={true} />
                <MenuDivider x={0} y={6.5} w={43} h={1.5} />
                <MenuText text="Tragic Clown Jr." x={0} y={6} class="font-italic" />
                <MenuText text="1.65" x={35} y={6} bold={true} />
                <MenuText text="Tragic Clown Sr." x={0} y={11} class="font-italic" />
                <MenuText text="1.68" x={35} y={11} bold={true} />
                <MenuText text="Bigtop Burgrito" x={0} y={16} class="font-italic" />
                <MenuText text=".95" x={36} y={16} bold={true} />
                <MenuText text="ChicagoStyle Nacho Slammer" x={0} y={21} class="font-italic" />
                <MenuText text="1.50" x={55} y={21} bold={true} />
                <MenuText text="Chicky Rippies" x={0} y={26} class="font-italic" />
                <MenuText text=".95" x={36} y={26} bold={true} />
                <MenuText text="Beefy Beaned Bongolicious" x={0} y={31} class="font-italic" />
                <MenuText text="Cheesy Bowl" x={0} y={36} class="font-italic" />
                <MenuText text="1.40" x={35} y={36} bold={true} />
                <MenuImage src={kibble} x={60} y={-2} w={40} />

                <MenuDivider x={0} y={46} w={43} h={19} class="border-radius-4" />
                <MenuText text="Make a BongoMeal" x={2} y={46} header={true} textClass="text-white" />
                <MenuText text="- one main" x={6} y={49} size={18} textClass="text-blue" />
                <MenuText text="- one side" x={6} y={53} size={18} textClass="text-blue" />
                <MenuText text="- one slurp" x={6} y={57} size={18} textClass="text-blue" />

                <MenuText text="Side Shows" x={68} y={32} size={28} header={true} />
                <MenuDivider x={50} y={38.5} w={43} h={1.5} />
                <MenuText text="Beans with a Z" x={50} y={37} class="font-italic" />
                <MenuText text=".50" x={85} y={37} bold={true} />
                <MenuText text="Ringaling 3Ring" x={50} y={42} class="font-italic" />
                <MenuText text="Onion Hoops" x={50} y={47} class="font-italic" />
                <MenuText text=".75" x={85} y={47} bold={true} />
                <MenuText text="n' Bits" x={50} y={52} class="font-italic" />
                <MenuText text="1.50" x={83} y={52} bold={true} />
                <MenuText text="Burrito Fries" x={50} y={57} class="font-italic" />
                <MenuText text=".75" x={85} y={57} bold={true} />
                <MenuImage src={freetoy} x={50} y={67} w={28} />

                <MenuText text="Slurps and Sips" x={0} y={65} size={28} header={true} />
                <MenuDivider x={0} y={71.5} w={43} h={1.5} />
                <MenuText text="All Drinksi™ Products!" x={0} y={71} class="font-italic" />
                <MenuText text="Puppy Size" x={4} y={76} class="font-italic" />
                <MenuText text=".45" x={36} y={76} bold={true} />
                <MenuText text="Doggie Size" x={4} y={81} class="font-italic" />
                <MenuText text=".55" x={36} y={81} bold={true} />
                <MenuText text="GoodBoy Bowl" x={4} y={86} class="font-italic" />
                <MenuText text=".65" x={36} y={86} bold={true} />
            </div>
        </div>
    </div>
}

function MenuText(
    props: {
        text: string,
        x: number,
        y: number,
        size?: number,
        class?: string,
        textClass?: string,
        header?: boolean,
        bold?: boolean
    }
) {
    const header = props.header !== undefined ? props.header : false;
    const textClass = props.textClass !== undefined ? props.textClass : 'text-taco-pink';
    const className = "pos-abs " + textClass + " " + (props.class !== undefined ? props.class : '');
    const size = props.size !== undefined ? props.size : 24;
    const bold = props.bold !== undefined ? props.bold : false;

    return header
        ? <h2 className={className} style={{ left: props.x + "%", top: props.y + "%", fontSize: size }}>
            { bold ? <b>{ props.text }</b> : props.text }
        </h2>
        : <p className={className} style={{ left: props.x + "%", top: props.y + "%", fontSize: size, padding: "0px 8px" }}>
            { bold ? <b>{ props.text }</b> : props.text }
        </p>
}

function MenuDivider (
    props: {
        x: number,
        y: number,
        w: number,
        h: number,
        class?: string
    }
) {
    const className = props.class !== undefined ? props.class : '';

    return <div className={"pos-abs bg-taco-teal " + className} style={{ 
        left: props.x + "%",
        top: props.y + "%",
        width: props.w + "%",
        height: props.h + "%",
        margin: "0px 8px"
    }} />
}

function MenuImage (
    props: {
        src: string,
        x: number,
        y: number,
        w: number,
        h?: number
    }
) {
    return props.h !== undefined 
    ? <img src={props.src} className="pos-abs" style={{
        left: props.x + "%",
        top: props.y + "%",
        width: props.w + "%",
        height: props.h + "%"
    }} />
    : <img src={props.src} className="pos-abs" style={{
        left: props.x + "%",
        top: props.y + "%",
        width: props.w + "%"
    }} />
}